import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type SimulatePaymentSuccessResult,
  postAdminTransactionsPublicIDSimulateSuccess,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { transactionStatusKeys } from "Api/Queries/Transactions/useTransactionStatus";
import { transactionsDetailKeys } from "Api/Queries/Transactions/useTransactionsDetail";
import { transactionsKeys } from "Api/Queries/Transactions/useTransactions";

/**
 * Test/staging only: marks a sandbox bank payment as settled the way a bank "paid" status would.
 * The backend answers 404 where the feature is switched off, so a stale UI cannot do anything on production.
 */
export const useSimulatePaymentSuccessMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      postAdminTransactionsPublicIDSimulateSuccess(publicID),
    ),
    onSuccess: (_result: SimulatePaymentSuccessResult, publicID: string) => {
      queryClient.invalidateQueries({
        queryKey: transactionStatusKeys.byPublicId(publicID),
      });
      queryClient.invalidateQueries({ queryKey: transactionsDetailKeys.all });
      queryClient.invalidateQueries({ queryKey: transactionsKeys.all });
    },
  });
};
